import { render, staticRenderFns } from "./booleanChoiceButtons.vue?vue&type=template&id=4ccf02f2"
import script from "./booleanChoiceButtons.vue?vue&type=script&lang=js"
export * from "./booleanChoiceButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports